import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 221C1942-DB8B-40D9-AED7-B202C0085832
 * name file-rotate-right-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-rotate-right-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileRotateRightOutlineIcon = createSvgIcon(<><path d="M20 11H23L19 15L15 11H18C18 7.69 15.31 5 12 5L11 5.08V3.06L12 3C16.42 3 20 6.58 20 11M9 7H5C3.9 7 3 7.9 3 9V18C3 19.11 3.9 20 5 20H11C12.11 20 13 19.11 13 18V11L9 7M11 18H5V9H8V12H11V18Z" /></>, 'FileRotateRightOutlineIcon');
export default FileRotateRightOutlineIcon